export default{
  "Video Compressor": "Video Kompressor",
  "HitPaw Online Video Compressor": "HitPaw online Video Kompressor",
  "Best video compressor tool to reduce video file size online without losing quality.": "Bestes Videokompressor-Tool zum Reduzieren der Videodateigröße online ohne Qualitätsverlust.",
  "Quality": "Qualität",
  "Small Size": "Kleine Größe ({{num}}%)",
  "High Quality": "Hohe Qualität ({{num}}%)",
  "Frame Rate": "Bildrate",
  "Resolution": "Auflösung",
  "Keep Resolution": "Auflösung halten",
  "Format": "Format",
  "Compress": "Komprimieren",
  "Compressing": "Komprimieren…",
  "Compress New": "Neue komprimieren",
  "xx% reduction in size!": "Verkleinerung des Volumens um {{num}}%",
  "Compressed successfully, your file is now xxMB.": "Komprimierung erfolgreich, Ihre Datei ist jetzt <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p> groß",
  "Compression Failed": "Komprimierung fehlgeschlagen",
};